(function () {
  // Soft fade-up as sections scroll into view. Skipped for reduced-motion users
  // and in the theme editor, and everything stays visible if this script fails.
  try {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.Shopify && Shopify.designMode) return;

    var targets = document.querySelectorAll(
      'main .card, main .hxn__card, main .hxs__row, main .hxs__card, main .story, main .gift__card, main .reviews .wrap > h2, main .section-head, main .hxn__head'
    );
    if (!targets.length) return;
    document.documentElement.classList.add('hx-motion');

    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    Array.prototype.forEach.call(targets, function (el, i) {
      // Anything already on screen when the page loads is shown straight away
      if (el.getBoundingClientRect().top < vh) return;
      el.classList.add('hx-reveal');
      el.style.transitionDelay = ((i % 3) * 80) + 'ms';
      io.observe(el);
    });

    // Safety net: never leave anything hidden
    setTimeout(function () {
      document.querySelectorAll('.hx-reveal:not(.is-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < (window.innerHeight || 800)) el.classList.add('is-in');
      });
    }, 3000);
  } catch (e) {
    document.documentElement.classList.remove('hx-motion');
  }
})();
